export type CardVariant = 'campaign' | 'campaignOverflow' | 'collectible' | 'collection' | 'mission' | 'benefit' | 'default';

export interface GridConfig {
    columns: {
        xs: number;
        sm: number;
        md: number;
        lg: number;
        xl: number;
    };
    gap?: number;
}


export const GRID_VARIANTS: Record<CardVariant, GridConfig> = {
    campaign: {
        columns: {
        xs: 1,
        sm: 1,
        md: 2,
        lg: 3,
        xl: 3,
        },
        gap: 32
    },

    campaignOverflow: {
        columns: {
        xs: 1,
        sm: 1,
        md: 2,
        lg: 3,
        xl: 3,
        },
        gap: 32
    },

    collection: {
        columns: {
        xs: 1,
        sm: 1,
        md: 1,
        lg: 2,
        xl: 2,
        },
        gap: 32
    },

    collectible: {
        columns: {
        xs: 1,
        sm: 1, 
        md: 2, 
        lg: 3, 
        xl: 3,
        },
        gap: 32
    },

    mission: {
        columns: {
        xs: 1,
        sm: 1,
        md: 2,
        lg: 2,
        xl: 2,
        },
        gap: 32
    },

    benefit: {
        columns: {
        xs: 1,
        sm: 2,
        md: 3,
        lg: 4,
        xl: 4,
        },
        gap: 24
    },

    default: {
        columns: {
        xs: 1,
        sm: 2,
        md: 3,
        lg: 4,
        xl: 4,
        },
        gap: 24
    }

};

export interface GridCardsProps<T> {
    items: T[];
    title?: string;
    renderItem: (item: T, index: number) => React.ReactNode;
    variant?: CardVariant;
    gap?: number;
}